import axis from '../../modules/axis';
function axisDefault(scale, axisToggle) {
  let axisTitle = this.axisTitles().filter(
    d => d.target === axisToggle.target && (!d.field || d.field === axisToggle.field) && (!d.shape || d.shape === axisToggle.shape)
  );
  if (axisTitle.length > 0) axisTitle = axisTitle[0];
  else axisTitle = null;

  //TODO: format 넘겨올 경우 처리 해줘야함. 시간과 수치 포맷 구별해야함
  let curAxis = axis();
  curAxis.scale(scale)
    .target(axisToggle.target)
    .field(axisToggle.field)
    .orient(axisToggle.orient)
    .title(axisTitle ? axisTitle.title : axisToggle.title)
    .titleOrient(axisToggle.titleOrient)
    .transition(this.transition());
  if(axisToggle.tickPadding !== undefined) curAxis.tickPadding(axisToggle.tickPadding);
  if(axisToggle.thickness !== undefined) curAxis.thickness(axisToggle.thickness);
  if(axisToggle.showTitle !== undefined) curAxis.showTitle(axisToggle.showTitle);
  if(axisToggle.showDomain !== undefined) curAxis.showDomain(axisToggle.showDomain);
  if(axisToggle.showTicks !== undefined) curAxis.showTicks(axisToggle.showTicks);
  this.axisExec(axisToggle.target, axisToggle.field, curAxis);
  return curAxis;
}

export default axisDefault;


// WEBPACK FOOTER //
// ../node_modules/daisy-chart/src/layouts/rectLinear/axisDefault.js